import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

export interface UsecaseCardData {
  id: string;
  title: string;
  shortDescription: string;
  imageSrc: string;
  tagIcon: string;
  tagLabel: string;
  link?: string;
}

@Component({
  selector: 'app-usecase-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './usecase-card.html',
  styleUrl: './usecase-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsecaseCard {
  private readonly router = inject(Router);

  @Input({ required: true }) card!: UsecaseCardData;

  onViewClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.card.link) {
      void this.router.navigateByUrl(this.card.link);
      return;
    }
    void this.router.navigate(['/usecases'], {
      fragment: this.card.id,
      replaceUrl: true,
    });
  }
}
